import React, { useContext } from 'react';
import { Button } from '@sm/wds-react';
import { IconLogoGoldie } from '@sm/wds-icons';
import ThemeContext from '~app/components/Survey/ThemeContext';
import checkDarkMode from '~app/helpers/luminance';
import './footer.scss';

const Footer = () => {
  const themeCtx = useContext(ThemeContext);
  const backgroundColor = themeCtx.common?.backgroundColor || '#fff';
  const isDarkMode = checkDarkMode(backgroundColor);
  const goldieLogoColor = isDarkMode ? 'dark-muted' : 'primary';
  const ctaColor = isDarkMode ? 'black' : 'primary';

  return (
    <footer className="sm-footer--container">
      <div className="sm-footer--content">
        <a className="sm-footer--logo" href="/?ut_source=quiz_results" target="_blank" rel="noreferrer">
          <IconLogoGoldie size="xl" color={goldieLogoColor} />
        </a>
        <div className="sm-footer--text">All set! Now create your own interactive quiz.</div>
      </div>
      <div className="sm-footer--content">
        <Button
          size="md"
          color={ctaColor}
          target="_blank"
          href="/create/?create=scratch&quiz=true&ut_source=quiz_results"
          rel="noreferrer"
        >
          Get started
        </Button>
      </div>
    </footer>
  );
};

export default Footer;
